import { Component, reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import DashboardCompany from '@/components/dashboard/DashboardCompany.vue';
import DashboardTempWorker from '@/components/dashboard/temp-worker/DashboardTempWorker.vue';
import { upperFirst } from 'lodash-es';

type Props = SetupProps<typeof DashboardViewSetupService.props>
type ReadableUserType = 'agency' | 'client' | 'tempWorker';

export default class DashboardViewSetupService extends BaseSetupService<Props> {
	static readonly props = {};

	private readonly state = reactive({ targetDashboard: undefined as Undef<string> });

	readonly components : Record<ReadableUserType, Component>= {
		'agency': DashboardCompany,
		'client': DashboardCompany,
		'tempWorker': DashboardTempWorker,
	};

	get targetDashboard () {
		if (this.self.readableUserType) {
			return this.components[this.self.readableUserType as ReadableUserType];
		}
	}

	constructor (props?: Props) {
		super(props);
	}

	onMounted () {
		this.state.targetDashboard = `Dashboard${upperFirst(this.self.readableUserType)}`;
	}
}
